import React, { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Check, ChevronsUpDown, X } from "lucide-react";

export function MemberCombobox({ members, value, onChange, disabled, testId, placeholder = "Not assigned", emptyText = "No eligible Support Team members.", clearable = true, ariaLabel = "Choose support member" }) {
  const [open, setOpen] = useState(false);
  const current = members.find((m) => m.member_id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" disabled={disabled} data-testid={testId} aria-label={ariaLabel}
          className="w-full h-10 rounded-md border border-slate-200 bg-white px-3 text-left text-sm flex items-center justify-between gap-2 hover:border-[#006090]/50 focus:outline-none focus:ring-2 focus:ring-[#006090]/30 disabled:opacity-60 transition-colors">
          <span className={`truncate ${current ? "text-slate-800" : "text-slate-400"}`}>{current ? current.name : placeholder}</span>
          <ChevronsUpDown className="w-4 h-4 text-slate-400 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[var(--radix-popover-trigger-width)] min-w-[260px] bg-white" align="start">
        <Command filter={(v, s) => (v.toLowerCase().includes(s.toLowerCase()) ? 1 : 0)}>
          <CommandInput placeholder="Search name or email…" data-testid={`${testId}-search`} />
          <CommandList className="max-h-64">
            <CommandEmpty>{emptyText}</CommandEmpty>
            <CommandGroup>
              {value && clearable && (
                <CommandItem value="__clear__ clear not assigned" onSelect={() => { setOpen(false); onChange(null); }}
                  data-testid={`${testId}-clear`} className="text-rose-600">
                  <X className="w-4 h-4 mr-2" /> Clear (Not assigned)
                </CommandItem>
              )}
              {members.map((m) => (
                <CommandItem key={m.member_id} value={`${m.name} ${m.email || ""} ${m.member_id}`}
                  onSelect={() => { setOpen(false); onChange(m.member_id); }} data-testid={`${testId}-opt-${m.member_id}`}>
                  <Check className={`w-4 h-4 mr-2 shrink-0 ${m.member_id === value ? "opacity-100 text-[#006090]" : "opacity-0"}`} />
                  <span className="min-w-0">
                    <span className="block truncate text-sm text-slate-800">{m.name}</span>
                    <span className="block truncate text-xs text-slate-500">{m.email || "No email"}</span>
                  </span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
